<template>
  <div>
    <div class="d-flex align-center px-0 data_table_header_text_color--text text-caption font-weight-bold">
      <div>{{ $t('triggersHistories.calls') }}</div>
      <v-spacer></v-spacer>
      <div>{{ $t('triggersHistories.status') }}</div>
    </div>
    <v-divider class="mt-1"></v-divider>
    <v-card
      v-for="(call, index) in calls"
      :key="call._id"
      outlined
      rounded
      class="my-2 d-flex align-center px-4 py-2"
    >
      <div class="text-none">{{ call.name || index + 1 }}</div>
      <v-spacer></v-spacer>
      <v-chip
        v-if="call.status"
        :color="getTriggerStatusBackgroundColor(call.status)"
        :text-color="getTriggerStatusTextColor(call.status)"
        small
      >
        {{ getStatusTranslation(call.status) }}
      </v-chip>
    </v-card>
  </div>
</template>

<script>
  import { getTriggerStatusBackgroundColor, getTriggerStatusTextColor } from '../../helpers/helper'

  export default {
    name: 'TriggerCallsPanel',
    props: {
      calls: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      getStatusTranslation(statusValue) {
        const status = this.status.find((status) => status.value === statusValue)
        return status ? status.text : statusValue
      },
      getTriggerStatusBackgroundColor,
      getTriggerStatusTextColor,
    },
    computed: {
      status() {
        return [
          { text: this.$t('triggersHistories.processing'), value: 'processing' },
          { text: this.$t('triggersHistories.success'), value: 'success' },
          { text: this.$t('triggersHistories.error'), value: 'error' },
          { text: this.$t('triggersHistories.relaunched'), value: 'relaunched' },
          { text: this.$t('triggersHistories.relaunchFailed'), value: 'relaunch_failed' },
        ]
      },
    },
  }
</script>
